import {WorkSansBold} from "@irati/ui/src/global/fonts"
import {Label} from "@irati/ui/src/Typography"
import {LabelProps} from "@irati/ui/src/Typography/Label"
import styled, {css} from "styled-components"

export type StyledLabelProps = LabelProps & {
  bold?: boolean
  highlighted?: boolean
}

export const StyledLabel = styled(Label)<StyledLabelProps>`
  white-space: nowrap;

  ${({bold, large, highlighted, textDecoration, theme}) => css`
    ${large && "font-size:  16px;"}
    ${highlighted && "font-size: 18px;"}
    ${(bold || large || highlighted) && WorkSansBold};
    ${textDecoration &&
    `
      color: ${theme.colors.utility.contrast};
      text-decoration-thickness: 2px;
    `}
    text-decoration-color: ${theme.colors.tertiary.r_400};
  `}

  img {
    width: 16px;
    height: 16px;
  }
`

export const Container = styled.div`
  display: flex;
  ${({theme}) => `
      padding: ${theme.spacing.one};
      background: ${theme.colors.greys.grey03};
      border-radius: ${theme.border.radius.medium};
  `};
`
